import React, { useState, useRef, useEffect } from 'react';
import { Label } from "reactstrap";

function UploadLogo({ size = "lg", src = "", onChange }) {
  const imageRef = useRef();
  const [previewImg, setPreviewImg] = useState(null);

  async function handleFileChange(e) {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onload = async (event) => {
      setPreviewImg(event.target.result);
      onChange(e.target.files[0]);
    }
    reader.readAsDataURL(file);
  }
  
  return (
    <div className="profile-user position-relative d-inline-block mx-auto mb-2">
      <div className="rounded-circle avatar-xl d-flex align-items-center justify-content-center img-thumbnail user-profile-image">
        <img src={previewImg ? previewImg : src}
          ref={imageRef}
          className={`rounded-circle avatar-${size}`}
          style={{ objectFit: "contain" }}
          alt=' '
          draggable="false"
        />
      </div>
      <div className="avatar-xs p-0 rounded-circle profile-photo-edit">
        {/* <Input id="profile-img-file-input" type="file"
                      className="profile-img-file-input" onChange={handleFileChange} /> */}
        <input type='file' className='invisible' id='img' onChange={handleFileChange} />
        <Label htmlFor="img"
          className="profile-photo-edit avatar-xs">
          <span className="avatar-title rounded-circle bg-light text-body">
            <i className="ri-camera-fill"></i>
          </span>
        </Label>
      </div>
    </div>
  )
}

export default UploadLogo
